import { useNavigate, useLocation } from "react-router-dom";
import { Bot, Search, Users } from "lucide-react";
import styles from "./PageSwitcher.module.css";
import { useAgents } from "../../agentContext";

const AGENT_ICONS: Record<string, React.ReactNode> = {
    isa: <Bot size={15} />,
    floor: <Users size={15} />,
};

const PageSwitcher = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { agents, loading } = useAgents();

    const isKnowledgeSearch = location.pathname === "/knowledge-search";

    return (
        <div className={styles.pageSwitcher}>
            {!loading && agents.map(agent => {
                const isActive = location.pathname === agent.route || (agent.route === "/isa" && location.pathname === "/");
                return (
                    <button
                        key={agent.id}
                        className={`${styles.switchButton} ${isActive ? styles.switchButtonActive : ""}`}
                        onClick={() => { if (!isActive) navigate(agent.route); }}
                    >
                        <span className={styles.switchIcon}>{AGENT_ICONS[agent.id] ?? <Bot size={15} />}</span>
                        {agent.name}
                    </button>
                );
            })}
            <button
                className={`${styles.switchButton} ${isKnowledgeSearch ? styles.switchButtonActive : ""}`}
                onClick={() => { if (!isKnowledgeSearch) navigate("/knowledge-search"); }}
            >
                <Search size={15} className={styles.switchIcon} />
                Zoeken
            </button>
        </div>
    );
};

export default PageSwitcher;
